export default __webpack_public_path__ + "static/media/FastorLogo.bd5e07fb.svg";